export const CATEGORY_FALLBACK = [
  {
    Nome: "Carros elétricos",
    Url: "carros-eletricos",
    Categoria: "1840168",
    NomeCategoria: "Carros elétricos",
    CorPrimaria: "#c96601",
    CorSecundaria: "#d8d100",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/498ea3c9-2970-4597-9001-231c8a64656e_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/cdb35e13-66a2-4653-8414-f41f408e34da_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/c3402e1d-82fe-4005-8f6b-154e168cc114_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/6d97a796-670e-401a-a279-1b0fcda6e850_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros elétricos",
    DataInclusao: "2019-03-27T11:06:07.707",
  },
  {
    Nome: "Hatches",
    Url: "hatches",
    Categoria: "1840177",
    NomeCategoria: "Hatches",
    CorPrimaria: "#000000",
    CorSecundaria: "#0088ff",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/69266426-8221-4f0b-8567-236ff916a84e_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/980c1c63-9e76-490e-b460-af82933530ae_CardDesktop.jpg",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/1fdd3916-3b13-4f88-b19f-92bb286a4878_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/332fd63d-4606-4721-a33a-f16a19a32879_CardMobile.jpg",
    Descricao: "Veja as melhores ofertas de carros hatch",
    DataInclusao: "2018-12-10T19:55:04.4",
  },
  {
    Nome: "Picapes",
    Url: "picapes",
    Categoria: "1840172",
    NomeCategoria: "Picapes",
    CorPrimaria: "#73c7d2",
    CorSecundaria: "#027eb5",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/fe8eeb39-c195-416a-9c62-71cdb25ba998_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/2e948af3-f8a6-41e0-a8da-594248b7c4bc_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/1a929d07-4ad4-4a2c-a7e9-d4fe103bca89_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/507b05cc-4af7-4d48-96f5-22ca1b545ffc_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de picapes na Webmotors",
    DataInclusao: "2018-12-10T19:42:16.717",
  },
  {
    Nome: "Sedans",
    Url: "sedans",
    Categoria: "1840171",
    NomeCategoria: "Sedans",
    CorPrimaria: "#000000",
    CorSecundaria: "#c00300",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/5d908e0d-0796-484f-b1fc-1b236ad4cc29_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/0c5460ff-9f6d-4835-8f93-68e7b8360098_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/f5b7821c-bbb4-487e-98a8-b82194de101b_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/28904da6-5db0-42e1-b74c-45fb9c83909f_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros sedan",
    DataInclusao: "2018-12-10T19:35:23.543",
  },
  {
    Nome: "SUVs",
    Url: "suvs",
    Categoria: "1840173",
    NomeCategoria: "SUVs",
    CorPrimaria: "#160083",
    CorSecundaria: "#7d9ebf",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/12381e5b-83c9-4da3-a6dc-caa01f594239_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/e0bacaf7-e920-42c0-98e5-8557cbb806ea_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/c22481a1-17a4-4788-b5ab-5a63733236f5_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/e849a8dc-1dff-4535-ac80-28273ce89947_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros SUV",
    DataInclusao: "2019-03-27T11:02:07.707",
  },
  {
    Nome: "Carros econômicos",
    Url: "carros-economicos",
    Categoria: "1840156",
    NomeCategoria: "Carros econômicos",
    CorPrimaria: "#01325d",
    CorSecundaria: "#0b83cc",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/8fda0758-aa52-46f0-ab91-c403d192d423_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/2393ed64-e935-43ec-a4e7-eb688c4760ca_CardDesktop.jpg",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/ebff1f9b-afab-4908-a966-7a194cc8b5b5_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/807577e8-f8f8-4744-ac73-ef03697e3e28_CardMobile.jpg",
    Descricao: "Veja as melhores ofertas de carros econômicos",
    DataInclusao: "2019-03-27T11:03:07.707",
  },
  {
    Nome: "Carros para família",
    Url: "carros-para-familia",
    Categoria: "1840160",
    NomeCategoria: "Carros para família",
    CorPrimaria: "#e99100",
    CorSecundaria: "#000000",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/a1f56603-0b7d-4e1f-84eb-6436c9f1bcc3_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/fda817cf-1d84-49c0-8db4-aa028e731bd6_CardDesktop.jpg",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/7caa47f3-a611-42f6-9ff7-8dcb0d483625_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/68928b84-9d65-4987-8a4a-c1d511cbfa79_CardMobile.jpg",
    Descricao: "Veja as melhores ofertas de carros para família",
    DataInclusao: "2019-03-27T11:05:07.707",
  },
  {
    Nome: "Carros a diesel",
    Url: "carros-a-diesel",
    Categoria: "1840166",
    NomeCategoria: "Carros a diesel",
    CorPrimaria: "#030305",
    CorSecundaria: "#b70e00",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/b578b670-68e1-4b59-a6d9-b51ce3ef56c2_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/7529b723-6701-4b1f-809c-139f972b707f_CardDesktop.jpg",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/ec00fe06-7e88-4315-b7ff-6cc53c874bba_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/3fcfbf67-7651-4353-a180-f316d7c36d65_CardMobile.jpg",
    Descricao: "Veja as melhores ofertas de carros a diesel",
    DataInclusao: "2018-12-10T19:22:47.013",
  },
  {
    Nome: "Carros de luxo",
    Url: "carros-de-luxo",
    Categoria: "1840169",
    NomeCategoria: "Carros de luxo",
    CorPrimaria: "#000000",
    CorSecundaria: "#28aaac",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/fb240456-bcd6-4f25-99a3-9dac336ceb56_BannerDesktop.jpg",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/2a646b96-e989-4e26-854d-84f579bdf0f4_CardDesktop.jpg",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/1abb9a0f-472b-4189-ab1a-e287be965d2d_BannerMobile.jpg",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/374c685a-4f08-4106-b6e2-ccf192df4a1c_CardMobile.jpg",
    Descricao: "Veja as melhores ofertas de carros de luxo",
    DataInclusao: "2019-03-27T11:04:07.707",
  },
  {
    Nome: "Carros antigos",
    Url: "carros-antigos",
    Categoria: "1840164",
    NomeCategoria: "Carros antigos",
    CorPrimaria: "#015a96",
    CorSecundaria: "#de623e",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/2c9935da-7b42-48e1-86ba-a388628ffb26_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/3d159255-5a4f-4bdf-bfbb-426f23981f4e_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/16c819f9-5950-40b9-8495-b4c0d65a48fe_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/900ed892-fb95-476b-b642-33653f886a8e_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros antigos",
    DataInclusao: "2019-03-27T11:01:07.707",
  },
  {
    Nome: "Carros clássicos",
    Url: "carros-classicos",
    Categoria: "1840165",
    NomeCategoria: "Carros clássicos",
    CorPrimaria: "#030408",
    CorSecundaria: "#0161a8",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/29a9f229-c43c-4b9c-9a15-1b9130ffa8d4_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/29a9f229-c43c-4b9c-9a15-1b9130ffa8d4_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/becca723-3d86-4c6d-bfed-98a0ffb807e0_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/becca723-3d86-4c6d-bfed-98a0ffb807e0_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas de carros clássicos",
    DataInclusao: "2018-12-10T19:21:50.073",
  },
  {
    Nome: "Carros grandes",
    Url: "carros-grandes",
    Categoria: "1840161",
    NomeCategoria: "Carros grandes",
    CorPrimaria: "#b0a087",
    CorSecundaria: "#7d9ebf",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/5f78e802-c449-4bd6-b2af-1839a4f9c7bc_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/5f2e6b79-e19f-4ba0-8fae-9220f9e01259_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/7641c34b-1aec-4c61-aa7e-2e2c18a580c3_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/9bb7780d-5eae-4a33-baf5-f57a779c9683_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros grandes",
    DataInclusao: "2018-12-10T20:02:24.257",
  },
  {
    Nome: "Carros híbridos",
    Url: "carros-hibridos",
    Categoria: "1840167",
    NomeCategoria: "Carros híbridos",
    CorPrimaria: "#73a31c",
    CorSecundaria: "#2f4f0b",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/d7c1e1dd-58c4-401e-a558-f6f550cd847b_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/8d1f069a-6af2-4ff7-8c17-ecbec154ada0_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/38b3f338-e62b-45a9-a9f1-2ac71e5ee2e1_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/de4a712e-f3df-4340-b95c-5b1cf63366e3_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros híbridos",
    DataInclusao: "2018-12-10T19:23:45.62",
  },
  {
    Nome: "Carros importados",
    Url: "carros-importados",
    Categoria: "1840178",
    NomeCategoria: "Carros importados",
    CorPrimaria: "#6a6a68",
    CorSecundaria: "#291f1d",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/aac27def-ac74-4d93-b1b2-aebfda361eee_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/aac27def-ac74-4d93-b1b2-aebfda361eee_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/73b512de-44db-4827-a6fa-1103864ce028_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/73b512de-44db-4827-a6fa-1103864ce028_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas de carros importados",
    DataInclusao: "2018-12-10T19:55:58.007",
  },
  {
    Nome: "Carros para aplicativos",
    Url: "carros-para-aplicativos",
    Categoria: "1840159",
    NomeCategoria: "Carros para aplicativos",
    CorPrimaria: "#d12c18",
    CorSecundaria: "#0058cb",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/dc8b1eaf-e6ff-4eaf-a050-f5958743490d_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/7929f8bb-d724-4e48-9065-21387e376a74_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/643a4112-2507-441a-9f02-5ef823faf5f7_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/25106fdf-3258-4791-88ec-1e048c50b355_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros para aplicativos",
    DataInclusao: "2018-12-10T20:00:41.983",
  },
  {
    Nome: "Carros para PCD",
    Url: "carros-para-pcd",
    Categoria: "1840162",
    NomeCategoria: "Carros para PCD",
    CorPrimaria: "#cd1a1d",
    CorSecundaria: "#fe9100",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/f5601c21-c474-44c4-a62e-1b1556d16c85_BannerDesktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/c735c38f-0236-4c71-b15b-74489059e9a5_CardDesktop.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/d6d927f4-f7ba-4182-b7fe-c84e0befd0d7_BannerMobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/1c026735-8ab0-4a58-9301-ce9f3843c427_CardMobile.jpg",
    Descricao: "Veja as melhores ofertas de carros para PCD",
    DataInclusao: "2019-03-27T11:07:07.707",
  },
  {
    Nome: "Carros pequenos",
    Url: "carros-pequenos",
    Categoria: "1840174",
    NomeCategoria: "Carros pequenos",
    CorPrimaria: "#000000",
    CorSecundaria: "#000000",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/53807154-885c-4452-9347-6c698f6da8bb_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/53807154-885c-4452-9347-6c698f6da8bb_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/8f6960b0-ab97-483c-8034-13bd94728303_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/8f6960b0-ab97-483c-8034-13bd94728303_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas de carros pequenos",
    DataInclusao: "2018-12-10T19:51:08.163",
  },
  {
    Nome: "Carros populares",
    Url: "carros-populares",
    Categoria: "1840157",
    NomeCategoria: "Carros populares",
    CorPrimaria: "#1e0d13",
    CorSecundaria: "#263c54",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/096e7024-eea3-41f8-8c33-46a5a357ff35_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/096e7024-eea3-41f8-8c33-46a5a357ff35_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/8e292748-a5e4-4681-8550-d8fc3e14cea0_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/8e292748-a5e4-4681-8550-d8fc3e14cea0_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas de carros populares",
    DataInclusao: "2018-12-10T17:04:13.4",
  },
  {
    Nome: "Conversíveis",
    Url: "conversiveis",
    Categoria: "1840176",
    NomeCategoria: "Conversíveis",
    CorPrimaria: "#4481ba",
    CorSecundaria: "#175aa5",
    BannerDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerDesktop/3364e4a2-4fa3-4806-98a3-3e24d354f795_BannerDesktop.webp",
    CardDesktop:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardDesktop/cd09fda0-8e95-4842-ae94-201bac03175d_CardDesktop.webp",
    BannerMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/BannerMobile/7694963f-c151-4514-927b-a9f6b7b40bf6_BannerMobile.webp",
    CardMobile:
      "https://catalogo.webmotors.com.br/imagens/prod/fotos-temas/CardMobile/c97e12d8-e9aa-4562-a2d4-cdee593a89fe_CardMobile.webp",
    Descricao: "Veja as melhores ofertas de carros conversíveis",
    DataInclusao: "2019-03-27T10:59:07.707",
  },
  {
    Nome: "Primeiro carro",
    Url: "primeiro-carro",
    Categoria: "1840158",
    NomeCategoria: "Primeiro carro",
    CorPrimaria: "#9b6702",
    CorSecundaria: "#b9dafd",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/4d11fe70-663a-47a5-b3aa-ad0b9f106880_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/4d11fe70-663a-47a5-b3aa-ad0b9f106880_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/61c09330-0a4f-4715-b05f-fbec6a12264c_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/61c09330-0a4f-4715-b05f-fbec6a12264c_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas para escolher seu primeiro carro",
    DataInclusao: "2018-12-10T17:06:03.497",
  },
  {
    Nome: "Carros com 2 portas",
    Url: "carros-com-duas-portas",
    Categoria: "1840180",
    NomeCategoria: "Carros com 2 portas",
    CorPrimaria: "#c8b79b",
    CorSecundaria: "#e8e836",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/138b410e-3526-4f47-aee1-e99149f1ea0e_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/138b410e-3526-4f47-aee1-e99149f1ea0e_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/94b80c8e-e05a-4072-8a1c-fdd4d1dde319_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/94b80c8e-e05a-4072-8a1c-fdd4d1dde319_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas de carros com duas portas",
    DataInclusao: "2018-12-10T19:57:14.573",
  },
  {
    Nome: "Carros de 7 lugares",
    Url: "carros-de-7-lugares",
    Categoria: "1840170",
    NomeCategoria: "Carros de 7 lugares",
    CorPrimaria: "#711b02",
    CorSecundaria: "#ffaa01",
    BannerDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/eafe764a-52f8-4d5b-b044-c8b826ecca02_desktop.jpg",
    CardDesktop:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/desktop/thumbs/eafe764a-52f8-4d5b-b044-c8b826ecca02_desktop_80x80.jpg",
    BannerMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/7990076a-dceb-4b1b-b73e-7751abcded54_mobile.jpg",
    CardMobile:
      "https://www.webmotors.com.br/imagens/prod/fotos-temas/mobile/thumbs/7990076a-dceb-4b1b-b73e-7751abcded54_mobile_80x80.jpg",
    Descricao: "Veja as melhores ofertas de carros de 7 lugares",
    DataInclusao: "2018-12-10T19:34:19.503",
  },
];
